import server from './server';
export default {
    server,
};